import t from '../common/text';

export default (data) => {
    const adviceText = data.adviceText || t('cantaccess.explain');

    return `
    <div class="Form CantAccess">
      <div class="FormName">Cant Access</div>
      <div class="Explain">
        ${adviceText}  
      </div>         
    </div>
  `;
};
